import type { RefObject } from "react";
import { useCheckProfessionalQuery } from "@/entities/professional";
import { useAuthService } from "@/auth/useAuthService";
import signOut from "../../../../assets/sign-out.svg";
import { getProfessionalInfo } from "../../../utils";
import { Icons } from "../../../icons/Icons";
import { useModalStore } from "../../../stores/modalStore";
import Tooltip from "../../ui/Tooltip/Tooltip";
import { LogoIHSA } from "../../ui/LogoIHSA/LogoIHSA";
import { MascotSelector } from "../../ui/MascotSelector";
import { InfoModal } from "./component/InfoModal";
import {
  DigitalHealthText,
  HeaderContainer,
  HeaderContent,
  IconWrapper,
  LogoContainer,
  LogoDivider,
  LogoSection,
  MenuIcon,
  MenuToggle,
  ProfessionalName,
  RightSection,
  UserSection,
} from "./HeaderStyles";

interface HeaderProps {
  isMobileLayout?: boolean;
  isNavigationOpen?: boolean;
  showNavigationToggle?: boolean;
  onNavigationToggle?: () => void;
  navigationButtonRef?: RefObject<HTMLButtonElement | null>;
}

const Header = ({
  isMobileLayout = false,
  isNavigationOpen = false,
  showNavigationToggle = false,
  onNavigationToggle,
  navigationButtonRef,
}: HeaderProps) => {
  const { data } = useCheckProfessionalQuery();
  const { deleteTokens } = useAuthService();
  const { openModal } = useModalStore();

  const isProfessionalRegistered = data?.data?.professional_data_registered;
  const professionalInfo = getProfessionalInfo(data);

  const handleModal = () => {
    openModal(<InfoModal />);
  };

  const renderLogout = () => (
    <Tooltip title="Salir">
      <IconWrapper
        type="button"
        className="sign-out"
        onClick={deleteTokens}
        aria-label="Salir"
      >
        <img src={signOut} alt="" />
      </IconWrapper>
    </Tooltip>
  );

  return (
    <HeaderContainer data-testid="app-header">
      <HeaderContent>
        <LogoSection>
          {isMobileLayout && showNavigationToggle ? (
            <MenuToggle
              ref={navigationButtonRef}
              type="button"
              aria-label={
                isNavigationOpen
                  ? "Cerrar menú principal"
                  : "Abrir menú principal"
              }
              aria-expanded={isNavigationOpen}
              aria-controls="mobile-navigation-drawer"
              onClick={onNavigationToggle}
            >
              <MenuIcon aria-hidden="true" />
            </MenuToggle>
          ) : null}

          <LogoContainer>
            <LogoIHSA
              width={isMobileLayout ? 52 : 65}
              height={isMobileLayout ? 36 : 45}
            />
            {!isMobileLayout ? (
              <>
                <LogoDivider />
                <DigitalHealthText>Digital Health</DigitalHealthText>
              </>
            ) : null}
          </LogoContainer>
        </LogoSection>

        <RightSection>
          {isProfessionalRegistered && professionalInfo.hasData ? (
            <>
              <Tooltip title="Información">
                <IconWrapper
                  type="button"
                  onClick={handleModal}
                  aria-label="Información"
                >
                  <Icons name="iconInfo" />
                </IconWrapper>
              </Tooltip>

              {!isMobileLayout ? (
                <>
                  <LogoDivider />
                  <UserSection>
                    <MascotSelector />
                    <ProfessionalName>
                      {professionalInfo.fullName}
                    </ProfessionalName>
                  </UserSection>
                  <LogoDivider />
                </>
              ) : null}

              {renderLogout()}
            </>
          ) : (
            renderLogout()
          )}
        </RightSection>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
